<template>
  <div class="video-list-container">
    <InfoContainer
      id="basicForm"
      :infoTitle="InfoContainerConfig['infoTitle']"
      :contentConfig="InfoContainerConfig['infoContent']"
    >
      <template #basicInfo>
        <div class="list-content">
          <div class="top-line">
            <el-input placeholder="培训编号/资料主题" size="small" v-model="search"></el-input>
            <el-button type="primary" icon="el-icon-search" size="small" @click="filterList">查询</el-button>
            <el-button size="small" @click="clearList">重置</el-button>
          </div>
          <div class="add-button">
            <el-button type="primary" icon="el-icon-plus" size="small" v-if="permission.cloudTraining_add"  @click="$router.push({path: '/cloudTraining/add/-1'})">新增培训</el-button>
          </div>
          <div class="video-list" v-if="listData.length>0">
            <template v-for="item in listData" >
              <div class="video-one" :key="item.id" @click.stop="openVideoDetail(item)">
                <div class="left-pic">
                  <img :src="item.pic" alt="" >
                </div>
                <div class="right-content">
                  <div class="right-top-content">
                    <div class="video-title">
                      <span class="title-word">{{ item.subject }}</span>
                      <div class="button_view">
                        <span class="edit-button del-button" @click.stop="handleDelete(item.id)"  v-if="item.createUser==userInfo.user_id&&permission.cloudTraining_del" > <i class="el-icon-delete"></i> 删除</span>
                         <span class="edit-button" @click.stop="goEdit(item.id)" v-if="item.createUser==userInfo.user_id&&permission.cloudTraining_edit"  > <i class="el-icon-edit"></i> 编辑</span>
                         
                      </div>
                      
                    </div>
                    <div class="video-info">{{item.createTime.substring(0,11)}} 共{{ item.videos.length }}课</div>
                    <div class="video-number">
                      编号：{{ item.number }}
                      <span :class="[item.allowDownload == 1?'green-word':'red-word']">
                        <i v-if="item.allowDownload == 1" class="el-icon-download"></i>
                        <i v-else class="el-icon-circle-close"></i>
                        {{ item.allowDownload == 1?'可下载':'不可下载' }}</span>
                    </div>
                    <div class="video-intro">{{ item.material }}</div>
                  </div>
                  <div class="button-list">
                    <template v-for="i in item.videos">
                      <el-tooltip :key="i.courseId" class="item" effect="dark" :content="i.intro" placement="top-start">
                        <div class="video-button" :key="i.courseId" @click.stop="openVideo(item,i)">{{ i.seq }}</div>
                      </el-tooltip>
                    </template>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div  class="empty_wrapper" v-else>
               <a-empty description="暂无数据" />
            </div>
        </div>
      </template>

      <!-- 分页 -->
      <el-pagination
        v-if="listData.length>0"
        background
        layout="prev, pager, next"
        :total="paginationConfig.total"
        :current-page.sync="paginationConfig.currentPage"
        :page-size="paginationConfig.pageSize"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />

    </InfoContainer>
  </div>
</template>
<script>
import { getVideoList ,deleteVideo } from "@/api/cloudTraining/cloudTraning";
import InfoContainer from "@/components/infoContainer/infoContainer";
import { mapGetters } from "vuex";

export default {
  name: 'CloudTraingingList',
  data() {
    return {
      search: '',
      listData: [],
      InfoContainerConfig: {
        infoTitle: '',
        infoContent: [{
          title: '',
          prop: 'basicInfo'
        }]
      },
      paginationConfig: {
        layout: "total,pager,prev, next",
        total: 0,
        currentPage: 1,
        pageSize: 9
      }
    }
  },
  components: {
    InfoContainer
  },
  computed: {
    ...mapGetters(["userInfo",'permission']),
  },
  methods: {
    handleSizeChange(val) {},

    handleCurrentChange(val) {
      this.paginationConfig.currentPage = val
      this.getVideoList()
    },

    async getVideoList() {
      let params = {
        current: this.paginationConfig.currentPage,
        size: this.paginationConfig.pageSize,
        ...{search: this.search}
      }
      let res = await getVideoList(params)
      // console.info(res, 'getVideoList')
      this.listData = res.data.data.records
    },

    filterList() {
      this.paginationConfig.currentPage = 1
      this.getVideoList()
    },

    clearList() {
      this.search = ''
      this.paginationConfig.currentPage = 1
      this.getVideoList()
    },

    openVideo(item, videoItem) {
      this.$router.push({
        path: `/cloudTraining/detail/${item.id}`,
        query: {
          courseId: videoItem.id
        }
      })
    },

    goEdit(id) {
      this.$router.push({
        path: `/cloudTraining/edit/${id}`
      })
    },
    handleDelete(id) {
      let self = this;
     
        this.$confirm("确定删除选择的数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            
            let res = await deleteVideo({ ids: id });
            if (res.data.code == 200) {
              self.$message({
                type: "success",
                message: "删除成功",
              });
              self.getVideoList();
            }
          })
          .catch(() => {
            self.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
    openVideoDetail(item) {
      this.$router.push({
        path: `/cloudTraining/detail/${item.id}`
      })
    }
  },
  mounted() {
    this.getVideoList()
  }
}
</script>
<style lang="scss" scoped>
.video-list-container{
  /deep/ .info-container-temp .box-card .detail-one{
    padding: 20px 0px !important;
  }
  .el-pagination{
    text-align: right;
  }
  .list-content{
    .top-line {
      display: flex;
      justify-content: flex-start;
      margin-bottom: 15px;
      .el-input {
        width: 20%;
        margin-right: 15px;
      }
    }
    .video-list{
      padding: 20px 0 10px;
      min-height: 100px;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .video-one{
        display: flex;
        justify-content: space-between;
        background-color: #f9f9f9;
        width: 32%;
        height: calc((100vw - 292px)*.32*.45);
        padding: 10px;
        margin-right: 1%;
        margin-bottom: 15px;
        overflow: auto;
        cursor: pointer;
        .button-list{
          display: flex;
          justify-content: flex-start;
          .video-button{
            cursor: pointer;
            width: 24px;
            height: 24px;
            margin-right: 10px;
            background: rgba(64,158,255,0.00);
            border: 1px solid #ccc;
            border-radius: 4px;          
            font-size: 12px;
            font-family: '微软雅黑', sans-serif, '微软雅黑', sans-serif-400;
            font-weight: normal;
            line-height: 24px;
            text-align: center;
            transition: all 0.2s linear;    
          }
          .video-button:hover{
            color: #fff;
            background-color: #409eff;
            border-color: #409eff;
          }
        }
        .left-pic{
          width: 40%;
          height: 100%;
          margin-right: 10px;
          // background-color: #47ecff;
          overflow: hidden;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .right-content{
          width: 100%;
          overflow: hidden;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          .video-title{
            display: flex;
            justify-content: space-between;
            .title-word{
              font-size: 14px;
              font-weight: 600;
              line-height: 28px;
              color: #000;
              flex:1;
            }
            .button_view {
              display: flex;
            }
            .button_view {
              display: flex;
            }
            .edit-button{
              cursor: pointer;
              border: 1px dashed #409eff;
              font-size: 12px;
              color: #409eff;
              padding: 0px 5px;
              height: 22px;
              border-radius: 2px;
              display: flex;
              align-items: center;
              margin-left:6px;
              i{
                margin-right: 5px;
                color: #409eff;
              }
            }
            .del-button {
              color: #F47D79;
              border: 1px dashed #F47D79;
              i{
                 
                color: #F47D79 !important;
              }
            }
          }
          .video-info{
            width: 100%;
            font-size: 13px;
            line-height: 20px;
            color: #000;
          }
          .video-number{
            width: 100%;
            font-size: 12px;
            line-height: 20px;
            color: #999;
            span{
              margin-left: 10px;
            }
            .green-word{
              color: #71c179;
              i{
                color: #71c179;
              }
            }
            .red-word{
              color: #F47D79;
              i{
                color: #F47D79;
              }
            }
          }
          .video-intro{
            font-size: 12px;
            width: 100%;
            overflow-wrap: break-word;
            color: #999;
          }
        }
      }
    }
  }
}
.empty_wrapper {
  text-align: center;
}
</style>
